import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSystemStatus } from "../../services/systemStatus";
import SystemBlockedPage from "../systemBlockedPage";

// SISTEM_BLOCK: renderiza a página no lugar do conteúdo, sem rota dedicada
// (mesmo mecanismo de InternoPermissionRoute). Envolve o <Routes> em App.js.

// os dois logins continuam acessíveis
const ROTAS_LIBERADAS = ["/login", "/interno/login"];

const ehRotaLiberada = (pathname) => {
  const normalizado = pathname.replace(/\/+$/, "") || "/";
  return ROTAS_LIBERADAS.includes(normalizado);
};

// /mirror conta como interno: quem entra no espelho é o usuário interno
const ehLadoInterno = (pathname) =>
  pathname.startsWith("/interno") || pathname.startsWith("/mirror");

export default function SystemBlockGate({ children }) {
  const { blocked, motivo, whatsapp, email } = useSystemStatus();
  const { pathname } = useLocation();

  const liberado = !blocked || ehRotaLiberada(pathname);
  const interno = ehLadoInterno(pathname);
  // cliente logado: encerra a sessão e volta para /login
  const encerrarSessaoCliente = !liberado && !interno;

  useEffect(() => {
    if (encerrarSessaoCliente) localStorage.clear();
  }, [encerrarSessaoCliente]);

  if (liberado) return children;

  if (interno) {
    return (
      <SystemBlockedPage whatsapp={whatsapp} email={email} motivo={motivo} />
    );
  }

  return <Navigate to="/login" replace />;
}
